export { VpBackButton } from './VpBackButton';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpBackButton/index.js